/* eslint-disable no-useless-escape */
import Vue from "@/helper/initVue";

import {
  RasmusResetPasswordFromHash,
  RasmusResetPasswordFromHashConfig,
} from "@/features/rasmus-kids-club/users/reset_password";

export const initRasmusResetPasswordFromHash = () => {
  const el = document.getElementById("rasmus-reset-password-from-hash");

  if (!el) {
    return;
  }

  try {
    const dataSettings = el.getAttribute("data-settings");

    if (!dataSettings) {
      return;
    }

    const parsedSettings: RasmusResetPasswordFromHashConfig = JSON.parse(
      dataSettings
    );

    new Vue({
      el,
      render: (h) =>
        h(RasmusResetPasswordFromHash, {
          props: {
            settings: parsedSettings,
          },
        }),
    });
  } catch (err) {
    console.error('Failed to load module "RasmusResetPasswordFromHash"');
  }
};

initRasmusResetPasswordFromHash();
